var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7644 144.794C112.545 144.794 144.794 112.545 144.794 72.7644C144.794 32.9833 112.545 0.734375 72.7644 0.734375C32.9833 0.734375 0.734375 32.9833 0.734375 72.7644C0.734375 112.545 32.9833 144.794 72.7644 144.794Z",
    fill: "url(#paint0_linear_561_49273)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3006 71.984C54.2918 62.8678 68.266 56.8103 75.2831 53.8715C95.2547 45.535 99.453 44.0956 102.152 44.0356C102.752 44.0356 104.071 44.1556 104.971 44.8753C105.69 45.475 105.87 46.2547 105.99 46.8545C106.11 47.4542 106.23 48.7137 106.11 49.6733C105.031 61.0685 100.353 88.717 97.9536 101.432C96.934 106.829 94.9549 108.629 93.0357 108.809C88.8374 109.169 85.6587 106.05 81.6404 103.411C75.2831 99.2726 71.7445 96.6937 65.5671 92.6154C58.4301 87.9373 63.0482 85.3584 67.1265 81.1602C68.206 80.0806 86.6183 63.2876 86.9782 61.7882C87.0382 61.6083 87.0382 60.8886 86.6183 60.5288C86.1985 60.1689 85.5988 60.2889 85.119 60.4088C84.4592 60.5288 74.3834 67.246 54.7716 80.5005C51.8928 82.4796 49.3139 83.4392 46.9749 83.3792C44.3959 83.3193 39.478 81.9398 35.7595 80.7403C31.2614 79.3009 27.6629 78.5213 27.9628 76.0023C28.1427 74.6829 29.942 73.3634 33.3006 71.984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_49273",
    x1: 72.7044,
    y1: 0.734375,
    x2: 72.7044,
    y2: 143.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramPromo);
export default __webpack_public_path__ + "static/media/Telegram-Promo.4939e7603a6d369c8fba0ae7321fa3d5.svg";
export { ForwardRef as ReactComponent };